import {ElMessage, ElMessageBox} from "element-plus";
import store from "@/store";
import {$_ajax} from "@/utils/axiosApi";
import {Base64} from 'js-base64'

export const playMiles = {
    url: "https://scal-rest.jifen360.com/index.php",
    token: "dzr8EKb3TPlH7uZ1Qtaaxjatij2ibsJf",
    scalKeys: "sdfer43523fdf",
    scalChannelType: "JIFEN360"
}

export const _message = (type, message, timer = 3000, callBack = null) => {
    return ElMessage({
        customClass: "vea-message-info",
        type,
        message,
        duration: timer,
        onClose: () => {
            if (callBack) {
                callBack()
            }
        }
    })
}

export const _alert = (message, title, call = null, capt = null) => {
    return ElMessageBox.alert(message, title).then(() => {
        if (call) {
            call()
        }
    });
}
/**
 * 登录数据处理
 * @param loginType
 * @param data
 * @returns {*}
 * @constructor
 */
export const LoginAccountValue = (loginType, data) => {
    data.balance = parseFloat(data.general_amount) + parseFloat(data.other_amount);
    data.accountType = loginType
    if(loginType === 'scal'){
        data.phoneNumber = Base64.decode(data.phoneNumber)
    }
    return data;
}
/**
 * 数据前导0
 * @param number
 * @returns {string|*}
 */
export const number_zero = (number) => {
    return number < 10 ? `0${number}` : number
}

export const callSer = () => {
    window.location.href = "tel://4000-360-195"
}

export const balances = (balance) => {
    const value = parseFloat(balance);
    return isNaN(value) ? "0.00" : value.toFixed(2)
}

/**
 * 川航单点登录
 * @param query
 */
export const onWayFn = (query) => {
    $_ajax(`${process.env.VUE_APP_ONE_WAY}scal/check`, {params: query}).then(({data}) => {
        if (data.data) {
            store.commit("getUserInfo", LoginAccountValue('scal', data.data))
        } else {
            store.commit("removeUserInfo")
        }
    }).catch(() => store.commit("removeUserInfo"));
}
